import { render, staticRenderFns } from "./block-domain-in-emails.vue?vue&type=template&id=4bbf7154"
import script from "./block-domain-in-emails.vue?vue&type=script&lang=js"
export * from "./block-domain-in-emails.vue?vue&type=script&lang=js"
import style0 from "./block-domain-in-emails.vue?vue&type=style&index=0&id=4bbf7154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports